module.exports = __webpack_public_path__ + "img/blueDunes.c9632531.svg";